// extracted by mini-css-extract-plugin
module.exports = {"root":"Select__root","element":"Select__element","selected":"Select__selected","label":"Select__label","wrapper":"Select__wrapper","value":"Select__value"};